exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app-sidebar-section {\n    border-left: solid 1px rgba(0, 0, 0, 0.05);\n}\n", ""]);

// exports
